export enum ContactMethod {
  Email = 1,
  Address,
}
